import { useQuery } from '@tanstack/react-query';
import getStudyReports from '../api/getStudyReports';
import ReportsSource, { reportsSourceId } from '../types/ReportsSource';
import StudyReportItem from '../types/StudyReportItem';

export const STUDY_REPORTS_QUERY_KEY = 'StudyReports';

const EMPTY: StudyReportItem[] = [];

/** The study's reports; no request while `source` is unset (or its id is still empty). */
const useStudyReports = (source?: ReportsSource) => {
  const sourceId = source ? reportsSourceId(source) : '';

  const { data, ...rest } = useQuery({
    queryKey: [STUDY_REPORTS_QUERY_KEY, sourceId],
    queryFn: () => getStudyReports(source!),
    enabled: !!sourceId,
    staleTime: 60 * 1000,
  });

  return {
    reports: data?.items ?? EMPTY,
    legacyLookupFailed: !!data?.legacyLookupFailed,
    ...rest,
  };
};

export default useStudyReports;
